module.exports = __webpack_public_path__ + "img/maestro.283a9f7a.svg";